import type { UserState } from './types';

export const initialState: UserState = {
  _id: null,
  email: null,
  username: null,
  firstName: null,
  lastName: null,
  phoneNumber: null,
  gender: null,
  birthDate: null,
  searchName: null,
  tagline: null,
  shareableSettings: {
    _id: null,
    accountId: null,
    firstName: null,
    lastName: null,
    fullName: null,
    avatar: {
      _id: null,
      mimetype: null,
      url: null,
    },
    social: [],
  },
  facebookAuth: null,
  twitterAuth: null,
  instagramAuth: null,
  youTubeAuth: null,
  backgroundSettings: null,
  type: null,
  counters: {
    postCounter: {
      facebook: 0,
      instagram: 0,
      twitter: 0,
      marble: 0,
      total: 0,
    },
  },
  auths: [],
  links: [],
  gaLinks: [],
  stats: {
    analyticsData: null,
    loading: false,
  },
  linkPreviewPosts: [],
  previewImageUrl: '',
  emailAuth: {
    passed: false,
  },
  subscriptions: [],
  tooltips: [],
  meta: null,
  personaInfo: null,
  contactDetails: null,
};
